<div class="steps-container">
    <p-steps [model]="steps" [readonly]="true"></p-steps>
</div>
<div class="flex flex-column align-items-center">
    <h3 class="title">Agregar fotos</h3>
    <p>Debes cargar entre 3 y 10 imágenes</p>
</div>
<p-dialog header="Cargando imágenes" [modal]="true" [(visible)]="loading" [closeOnEscape]="false" [resizable]="false" [closable]="false" [blockScroll]="true">
    <div style="height: 105px;" class="flex justify-content-center">
        <p-progressSpinner strokeWidth="5"></p-progressSpinner>
    </div>
</p-dialog>
<div class="flex justify-content-evenly my-4">
    <form (ngSubmit)="endRegistration()">
        <p-button label="Finalizar registro" type="submit" [disabled]="this.fileReferences.length < 3" [loading]="loadingFinal"></p-button>
    </form>
</div>
<div class="flex justify-content-evenly my-3">
    <div class="w-11 md:w-6">
        <p-fileUpload name="uploadedFile[]" url="{{ uploadUrl }}" (onUpload)="onUpload($event)" [multiple]="true" [auto]="true"
            chooseIcon="pi pi-upload" styleClass="w-full" (onBeforeUpload)="onBeforeUpload()"
            chooseLabel="Buscar imágenes" uploadLabel="Cargar" cancelLabel="Cancelar" [maxFileSize]="5000000" accept="image/jpg,image/png,image/jpeg" [fileLimit]="20"
            invalidFileTypeMessageDetail="" invalidFileTypeMessageSummary="El archivo {0} no es una imagen."
            invalidFileLimitMessageSummary="" invalidFileLimitMessageDetail="Seleccione máximo {0} archivos.">
        </p-fileUpload>
    </div>
</div>
<div *ngIf="files.length" class="flex flex-row flex-wrap justify-content-evenly my-4 m-auto w-10">
    <div *ngFor="let response of files; index as i">
        <p-image src="{{ response.url }}" width="105px"></p-image>
        <p-button label="Eliminar" icon="pi pi-times" class="grey" (onClick)="removeImage(i)" ></p-button>
        <p [class.red]="response.status === 'error'" class="">{{ response.message }} </p>
    </div>
</div>